import type { Messages } from '../messages.js'

/**
 * Galician. `xogada` for flips, the word a Galician board game uses for a move.
 *
 * Written in the standard of the Real Academia Galega, which is the spelling the Wikipedia the
 * word list is drawn from uses.
 */
export const gl: Messages = {
  tag: 'gl',

  readingDictionary: 'Lendo o dicionario…',
  noWordList: 'Non hai lista de palabras para «{language}». Cree unha:  pnpm dictionary build',
  emptyWordList: 'A lista de palabras de «{language}» está baleira.',

  flips: 'xogadas',
  score: 'puntuación',
  words: 'palabras',
  round: 'rolda',
  ticksLeftLabel: 'Tempo restante nesta rolda',
  typeAWord: 'escriba unha palabra',
  tapPrompt: 'toque as letras para escollelas ou devolvelas, e logo {action}',

  boardOfTiles: 'Taboleiro de {n} fichas',
  faceDown: 'boca abaixo',
  wildCard: 'comodín',
  wildKey: 'calquera letra',
  letterReplaced: '{from} converteuse en {to}',
  letterSwap: 'CAMBIO DE LETRAS!',
  spentTile: 'ficha usada',
  hiddenWhilePaused: 'agochado mentres está en pausa',
  letterInWord: '{letter}, letra {position} da palabra',

  completeWord: 'Completar palabra',

  completeShort: 'Completar',
  reset: 'Limpar',
  pause: 'Pausa',
  resume: 'Retomar',
  newGame: 'Partida nova',
  paused: 'En pausa',
  outOfFlips: 'Sen xogadas',
  finalResult: '{score} por {words} en {rounds}',
  playAgain: 'Xogar outra vez',
  share: 'Compartir',
  shareCopied: 'Copiado.',
  shareSelect: 'Copie isto:',

  lettersSelect: 'as letras escollen',
  keysWild: 'tómase cando escribe unha letra que ningunha ficha amosa',
  clearsEvery: 'limpa todas as {letter} escollidas',
  undoLastLetter: 'desfacer a última letra',
  noWordsYet: 'Aínda ningunha palabra.',

  wordRejected: '{word}  {reason}',
  reasonDuplicate: 'xa atopada',
  reasonTooShort: 'curta de máis',
  reasonNotAWord: 'non é unha palabra',
  reasonAllFound: 'xa as ten todas',
  noSuchLetterUp: 'ningunha {letter} descuberta',
  nothingUp: 'nada descuberto',
  letterHidden: 'unha letra agochouse',
  shuffled: 'barallado',
  shuffledAndBilled: 'barallado, cobráronse {flips} sen usar',
  tooFewLetters: 'Quedan moi poucas letras',

  gameLanguage: 'lingua',
  interfaceLanguage: 'interface',
  dictionarySize: '{common} de uso común de {full} palabras',
  filterLanguages: 'Buscar unha lingua',
  noMatches: 'Sen coincidencias',

  nerdMode: 'modo para entendidos',
  rules: 'Regras',
  difficulty: 'dificultade',
  difficultyNames: { easy: 'fácil', medium: 'media', hard: 'difícil', insane: 'demencial' },
  pausedNoBoard: 'Esta partida non aparecerá na clasificación.',
  about: 'Acerca de',
  themeLabel: 'tema',
  themeNames: { traditional: 'tradicional', light: 'claro', contrast: 'alto contraste' },
  tiles: 'fichas (N)',
  secondsPerTick: 'segundos / batida',
  holdTicks: 'batidas de espera',
  minWord: 'palabra máis curta',
  startingFlips: 'xogadas iniciais',
  wildChance: 'probabilidade de comodín',
  replaceChance: 'probabilidade de cambio de letra',
  hideChance: 'probabilidade de agochar letra',
  wordCompleteMode: 'ao completar unha palabra',
  wordCompleteNames: { shuffle: 'barallar', spend: 'gastar', keep: 'conservar' },
  flipEconomy: 'retorno de xogadas',
  flipEconomyNames: {
    none: 'ningún',
    perLetter: 'por letra',
    fibonacci: 'fibonacci',
    overMinimum: 'sobre o mínimo',
  },
  repeatedLetterKey: 'tecla de letra repetida',
  keySchemeNames: { cycle: 'ciclo', advance: 'avanzar' },
  keySchemeHelp: {
    cycle:
      'A colle o seguinte A sen usar, e cando xa están todos na palabra, límpaos. ' +
      'Maiús+A tamén os limpa.',
    advance: 'A colle o seguinte A sen usar. Maiús+A limpa todos os A da palabra.',
  },

  whatThatMeans: 'Que quere dicir isto',
  factRound: 'rolda',
  factWholeBoardUp: 'todo o taboleiro descuberto durante',
  factRoundCosts: 'unha rolda custa',
  factFlipsBuy: 'as xogadas iniciais mercan',
  factThisBoard: 'este taboleiro',
  factBoardHadToAdmit: 'o taboleiro tiña que admitir',
  ticksAndSeconds: '{ticks}, {seconds}',
  wordsLongest: '{words}, a máis longa {longest}',
  wordsIncludingOneOf: '{words}, unha delas de {ceiling}',
  scorelessRounds: '{rounds} sen puntos',

  whatAWordPays: 'Canto paga unha palabra',
  columnLetters: 'letras',
  columnCost: 'custo',
  columnPoints: 'puntos',
  columnFlips: 'xogadas',
  columnNet: 'neto',

  canonicalRules: 'Regras canónicas de {difficulty}.',
  customRules:
    'Cambiado respecto do predefinido. As puntuacións con regras propias non se clasifican.',
  applyAndStart: 'Aplicar e comezar unha partida nova',
  changesNextGame: 'Os cambios aplícanse na seguinte partida.',
  presets: 'Predefinidos:',

  start: 'Comezar',
  restart: 'Reiniciar',
  quit: 'Deixalo',
  quitTitle: 'Quere deixar esta partida?',
  restartTitle: 'Quere reiniciar esta partida?',
  restartConfirm: 'Reiniciar',
  quitConfirm: 'Deixalo',
  keepPlaying: 'Seguir xogando',
  personalBest: 'As súas mellores partidas',
  newPersonalBest: 'Un novo récord persoal.',
  columnRank: '#',
  notRanked: 'Regras propias, así que esta partida non se clasifica.',
  notRankedPaused: 'O reloxo detívose, así que esta partida non se clasifica.',
  rankOfTotal: '{rank} de {total}',

  howToPlay: 'Como se xoga',

  backToGame: 'Volver á partida',
  welcomeTitle: 'Benvido a Blinkered',
  tutorialSkip: 'Omitir',
  tutorialNext: 'Seguinte',
  tutorialBack: 'Atrás',
  tutorialStart: 'Comezar a xogar',
  tutorialHideAgain: 'Non amosar isto outra vez',
  tutorialProgress: '{n} de {total}',
  tutorialSkipTitle: 'Omitir a presentación?',
  tutGoalTitle: 'Blinkered é unha carreira',
  tutGoalBody:
    'Comeza a partida cun número fixo de xogadas, e cada ficha que vira custa unha xogada. Cando as xogadas se esgotan, a partida remata. Formar palabras dá xogadas, e canto máis longa é a palabra, máis xogadas gaña.',
  tutSpentBody:
    'As letras que use nunha palabra quedan boca abaixo ata a rolda seguinte. Só un cambio de letra altera que letras hai no taboleiro.',
  tutChangeTitle: 'As letras poden cambiar',
  tutSameLetters:
    'Viu unha palabra que non chegou a xogar? As mesmas letras volven na rolda seguinte, baralladas en lugares novos.',
  tutPickLetters: 'Toque as letras que queira, en orde, para formar unha palabra.',
  tutMoreTurn: 'As fichas seguen a virar mentres pensa, así que aínda pode vir unha letra mellor.',
  tutTapBack:
    'Colleu unha que non quería? Tóquea outra vez para devolvela. Calquera, non só a última.',
  tutComplete: 'Prema Completar cando a palabra estea lista.',
  htBoardTitle: 'O taboleiro',
  htBoardBody:
    'As fichas viran unha a unha, nunha orde aleatoria. Coas descubertas fórmanse palabras.',
  htWordsTitle: 'As palabras',
  htWordsBody:
    'Forme unha palabra coas fichas descubertas escribindo ou premendo as letras en orde.',
  htFlipsTitle: 'As xogadas',
  htFlipsBody:
    'Cada ficha que vira custa unha xogada. Unha palabra completada devolve xogadas, e as palabras longas devolven máis. Cando as xogadas se esgotan, a partida remata.',
  htRoundTitle: 'A rolda',
  htRoundBody:
    'Cando vira a última ficha da rolda, todo o taboleiro queda un intre. Despois as fichas vólvense e barállanse, e comeza unha rolda nova.',
  htLanguagesTitle: 'As linguas',
  htLanguagesBody:
    'Hai {n}. Calquera taboleiro pode resolverse con palabras que a xente usa de verdade. Unha palabra pouco común tamén puntúa, se o dicionario a coñece.',
  htKeysTitle: 'O teclado',
  htWildTitle: 'Os comodíns',
  htWildBody:
    'Ás veces aparece un comodín no canto dunha letra. O comodín conta como calquera letra que faga unha palabra válida. Unha palabra xa completada non conta.',
  htHideTitle: 'Letras que se agochan',
  htHideBody:
    'Nos niveis máis difíciles unha letra descuberta pode virar soa e volver máis tarde na rolda. O temporizador gaña un tic por iso, en vermello. As letras xa escollidas non viran.',
  tutHideBody:
    'Nos niveis máis difíciles unha letra descuberta pode virar soa e volver máis tarde na rolda. As letras xa escollidas non viran.',
  htSwapTitle: 'Letras que cambian',
  htSwapBody:
    'Ás veces, entre roldas, unha letra é substituída por outra. Verá cal marchou e cal chegou.',
  htLevelsTitle: 'Os niveis',
  htLevelEasy:
    'As mesmas doce letras toda a partida, así que pode aprendelas e levar unha lista de palabras na cabeza. As fichas viran devagar, e o taboleiro enteiro vese abondo tempo para rematar a escolla.',
  htLevelMedium:
    'De cando en vez unha letra cambia, así que custa máis lembrar as palabras gardadas para despois. Menos tempo para mirar e menos para pensar.',
  htLevelHard:
    'As palabras de tres letras deixan de contar, e unha letra cambia case cada dúas roldas. O taboleiro apenas se amosa e xa se baralla.',
  htLevelInsane:
    'Todo á vez, a toda velocidade. O taboleiro baralla case xusto despois da última xogada.',
  htTouchTitle: 'A pantalla táctil',
  htTouchBody:
    'Toque unha ficha descuberta para coller a súa letra. Toque unha letra collida para devolvela. Completar e Limpar están debaixo do taboleiro.',

  accountTitle: 'A túa conta',
  menuProfile: 'O meu perfil',
  menuGames: 'As miñas partidas',
  menuPublicPage: 'A miña páxina pública',
  menuSignedInAs: 'Sesión iniciada como',
  signIn: 'Iniciar sesión',
  signOut: 'Pechar sesión',
  signInTitle: 'Inicia sesión ou rexístrate',
  signInLead: 'Unha conta garda as túas partidas, en todos os dispositivos.',
  signInKeepGame: 'Inicia sesión para gardar esta partida, e todas as seguintes.',
  continueWithApple: 'Continuar con Apple',
  continueWithGoogle: 'Continuar con Google',
  signInOr: 'ou',
  emailLabel: 'Correo',
  codeLabel: 'Código',
  emailMeACode: 'Enviádeme un código',
  working: 'Un intre…',
  sendNewCode: 'Enviar un código novo',
  codeSent: 'Mira o correo. O código dura 10 minutos.',
  notNow: 'Agora non',
  badEmail: 'Isto non parece un enderezo de correo.',
  badCode: 'Ese código non funcionou. Os códigos caducan aos 10 minutos e valen unha vez.',
  serverBusy: 'Non se puido contactar co servidor. Téntao noutro intre.',
  serverDown: 'Non se puido contactar co servidor.',
  offline: 'Sen conexión',
  leaderboardTitle: 'Clasificación',
  leaderboardEmpty: 'Aínda non hai partidas nesta clasificación. Se o primeiro.',
  leaderboardWouldBe: 'Onde quedaría esta partida',
  leaderboardThisGame: 'Esta partida',
  leaderboardRanksHere: 'Onde queda esta partida',
  leaderboardOutside: 'Fóra das cinco primeiras.',
  tutAccountTitle: 'Garda as túas puntuacións',
  tutAccountBody:
    'Unha conta garda as túas partidas, pon as túas puntuacións na clasificación e mantén o teu perfil.',
  ssoCancelled: 'Cancelouse o inicio de sesión.',
  ssoExpired: 'Tardou de máis. Inicia sesión outra vez.',
  ssoNoUsername: 'Non se puido rematar de crear a conta. Téntao noutro intre.',
  ssoFailed: 'Non funcionou. Téntao outra vez, ou usa o correo.',
  tabProfile: 'Perfil',
  countryAny: 'Prefiro non dicilo',
  findCountry: 'Buscar países',
  usernameLabel: 'Nome de usuario',
  bioLabel: 'Sobre min',
  countryLabel: 'País',
  bioHint: 'Sen ligazóns. {left}/{max}',
  save: 'Gardar',
  saving: 'Gardando…',
  saved: 'Gardado.',
  nameTaken: 'Ese nome xa o ten alguén.',
  nameTooShort: 'Un pouco máis longo, por favor.',
  nameTooLong: 'É longo de máis.',
  nameBadCharacters: 'Só letras, cifras, guións e guións baixos.',
  nameBadEdges: 'Ten que comezar e rematar cunha letra ou unha cifra.',
  nameMixedScripts: 'Escolle un só alfabeto e queda nel.',
  nameReserved: 'Parece un nome dos que damos nós. Escolle outro.',
  nameUnusable: 'Ese nome non se pode usar.',
  bioTooLong: 'Este campo admite {max} caracteres como moito.',
  bioHasLink: 'Aquí non se admiten ligazóns.',
  bioHasControl: 'Contén caracteres que aquí non caben.',
  bioUnusable: 'Ese texto non se pode usar.',
  gamesHeading: 'Partidas',
  gamesEmpty:
    'Aquí aínda non hai nada. As partidas que xogues coa sesión iniciada aparecerán aquí.',
  gamesEmptyShort: 'Aquí aínda non hai nada.',
  gamesLoading: 'Lendo as túas partidas…',
  theirGamesLoading: 'Lendo as súas partidas…',
  profileLoading: 'Lendo o perfil…',
  playerNotFound: 'Aquí non hai ninguén con ese nome.',
  columnWhen: 'Cando',
  columnRounds: 'roldas',
  columnGame: 'Partida',
  gameLoading: 'Lendo a partida…',
  gameUnreadable: 'Non se puido ler esta partida.',
  gameNotRanked: 'Xogada con regras modificadas, así que non entra na clasificación.',
  detailNotKept: 'As palabras e os taboleiros desta partida xa non se gardan.',
  openingBoard: 'O taboleiro inicial',
  roundByRound: 'Rolda a rolda',
  roundNothing: 'non se atopou nada',
  changeReplaced: '{letter} substituída na casa {slot}',
  changeWildOn: '{letter} comodín na casa {slot}',
  changeWildOff: '{letter} comodín retirado da casa {slot}',
  keepThisGame: 'Gardar esta partida',
  savedToYourGames: 'Gardada nas túas partidas.',

  reportThis: 'Denunciar',
  reportHeading: 'Denunciar isto',
  reportTheName: 'O nome',
  reportTheBio: 'A descrición',
  reportTheScore: 'A puntuación',
  reportWhy: 'Que ten de malo? Opcional.',
  reportSend: 'Enviar a denuncia',
  reportSent: 'Grazas. Alguén o revisará.',
  reportSignIn: 'Inicia sesión para denunciar algo.',
  reportGone: 'Iso xa non está.',
  reportCancel: 'Cancelar',

  deleteAccount: 'Eliminar a miña conta',
  deleteAccountWhat:
    'Isto elimina o teu perfil e todas as partidas que gardaches, para sempre. Non se pode desfacer.',
  deleteAccountAsk: 'Envíame un código',
  deleteConfirm: 'Eliminar para sempre',
  deleteGone: 'A túa conta xa non existe. Grazas por xogar.',
  deleteNoAddress:
    'Non hai un enderezo confirmado nesta conta, así que non se pode comprobar unha eliminación. Escríbenos e farémolo a man.',

  rulesetFacts: 'Palabras de {letters} · unha ficha nova cada {seconds}',
  plurals: {
    words: { one: '{n} palabra', other: '{n} palabras' },
    rounds: { one: '{n} rolda', other: '{n} roldas' },
    flips: { one: '{n} xogada', other: '{n} xogadas' },
    ticks: { one: '{n} batida', other: '{n} batidas' },
    points: { one: '{n} punto', other: '{n} puntos' },
    minLetters: { one: '{n} letra ou máis', other: '{n} letras ou máis' },
    seconds: { one: '{n} segundo', other: '{n} segundos' },
  },
}
